export default __webpack_public_path__ + "static/media/hht2_ep4_speaking_04.f7312ae9.png";